// /revisiones — Manos de Oro owner console (MDO-6, MDO-10 Calibración). Every human decision is the owner's (D13):
// viewers can look and grade calibration; only the owner can act — ops-mdo and mdo-api enforce it server-side.
import { useMemo } from "react";
import { Revisiones as RevisionesScreen, opsClient } from "@treesupply/mdo-ui";
import { supabase } from "../lib/supabase";

const OPS_MDO = `${import.meta.env.VITE_SUPABASE_URL || "https://nyyqgmpwmcrlxydjwecz.supabase.co"}/functions/v1/ops-mdo`;

export default function Revisiones() {
  const client = useMemo(
    () => opsClient(OPS_MDO, async () => (await supabase.auth.getSession()).data.session?.access_token ?? null),
    [],
  );
  return <RevisionesScreen client={client} />;
}
